import React from "react";
import { SessionProvider } from "./app/session/SessionContext.js";
import { SupportBadgeProvider } from "./modules/soporte/index.js";
import AppRouter from "./app/AppRouter.js";

export default function App() {
  return (
    <SessionProvider>
      <SupportBadgeProvider>
        <AppRouter />
      </SupportBadgeProvider>
    </SessionProvider>
  );
}
